var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function(option) {
      return _c("checkbox", {
        staticClass: "option",
        attrs: {
          value: option.value === _vm.value,
          label: option.label,
          disabled: !_vm.enabledOptions.includes(option.value)
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event ? option.value : undefined)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }